export default __webpack_public_path__ + "static/graffiti-logo-bw-f5880842afe18b55ea1ecfcd2f5ece31.png";